// Mock data for Rubicon Finservices

export const services = [
  {
    id: 1,
    title: "Mutual Funds",
    description: "Diversified portfolio management with top-performing mutual funds from leading AMCs",
    icon: "TrendingUp",
    features: ["Equity Funds", "Debt Funds", "Hybrid Funds", "ELSS"]
  },
  {
    id: 2,
    title: "AIF - Alternate Investment Fund",
    description: "Alternative investment opportunities for sophisticated investors seeking higher returns",
    icon: "Briefcase",
    features: ["Category I & II AIFs", "Private Equity", "Hedge Funds", "Expert Management"]
  },
  {
    id: 3,
    title: "PMS - Portfolio Management Services",
    description: "Personalized portfolio management tailored to your investment goals and risk profile",
    icon: "PieChart",
    features: ["Customized Strategies", "Direct Equity", "Professional Management", "Regular Monitoring"]
  },
  {
    id: 4,
    title: "SIF - Specialized Investment Funds",
    description: "Specialized investment solutions for high net-worth individuals and institutions",
    icon: "Target",
    features: ["Niche Strategies", "Institutional Grade", "Exclusive Access", "High Returns"]
  },
  {
    id: 5,
    title: "Fixed Deposits",
    description: "Secure fixed deposit options with competitive interest rates",
    icon: "Lock",
    features: ["High Returns", "Flexible Tenure", "Safe & Secure", "Easy Liquidity"]
  },
  {
    id: 6,
    title: "Insurance",
    description: "Comprehensive life and health insurance solutions for complete protection",
    icon: "Shield",
    features: ["Life Insurance", "Health Insurance", "Term Plans", "Investment Plans"]
  }
];


export const partners = [
{ name: "HDFC Mutual Fund", category: "mutual-fund" },
{ name: "ICICI Prudential", category: "mutual-fund" },
{ name: "SBI Mutual Fund", category: "mutual-fund" },
{ name: "Axis Mutual Fund", category: "mutual-fund" },
{ name: "Kotak Mutual Fund", category: "mutual-fund" },
{ name: "UTI Mutual Fund", category: "mutual-fund" },
{ name: "Bajaj Finance", category: "fixed-deposit" },
{ name: "HDFC ERGO", category: "insurance" },
{ name: "Tata AIA", category: "insurance" }];


export const testimonials = [
{
  id: 1,
  name: "Rajesh Kumar",
  role: "Business Owner",
  content: "Rubicon Finservices helped me achieve my financial goals with their expert guidance. Their SIP recommendations have given me excellent returns.",
  rating: 5
},
{
  id: 2,
  name: "Priya Sharma",
  role: "IT Professional",
  content: "Professional and trustworthy service. They helped me plan my retirement and child's education with the right investment mix.",
  rating: 5
},
{
  id: 3,
  name: "Amit Patel",
  role: "Entrepreneur",
  content: "Best financial advisors I've worked with. Their portfolio management service has consistently delivered great results.",
  rating: 5
}];


export const whyChooseUs = [
{
  id: 1,
  title: "Expert Guidance",
  description: "Professional advisor with years of experience in financial markets",
  icon: "Award"
},
{
  id: 2,
  title: "Personalized Solutions",
  description: "Customized investment strategies tailored to your financial goals",
  icon: "Users"
},
{
  id: 3,
  title: "Transparent Process",
  description: "Clear communication and no hidden charges policy",
  icon: "Eye"
},
{
  id: 4,
  title: "Wide Product Range",
  description: "Access to top mutual funds, insurance, and investment products",
  icon: "Grid"
}];


export const stats = [
{ label: "Clients Served", value: "1000+", icon: "Users" },
{ label: "Assets Under Advisory", value: "₹50Cr+", icon: "TrendingUp" },
{ label: "Years of Experience", value: "10+", icon: "Award" },
{ label: "Partner AMCs", value: "15+", icon: "Handshake" }];


export const contactInfo = {
  email: "communications@rubiconfinservices.com",
  phone: "+91 9674044566",
  whatsapp: "+91 9674044566",
  address: "6A Dr Rajendra Prasad Sarani, 4th Floor, R.No-20, Kolkata-700001",
  instagram: "@themutualfundguy",
  twitter: "@rubiconfin",
  linkedin: "linkedin.com/in/rohit-jain-bhansali"
};

// Mock form submission
export const submitContactForm = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Contact form submitted:", formData);
      resolve({ success: true, message: "Thank you! We'll contact you soon." });
    }, 1000);
  });
};

// Mock SIP calculation
export const calculateSIP = (monthlyInvestment, rateOfReturn, timePeriod) => {
  const months = timePeriod * 12;
  const monthlyRate = rateOfReturn / 12 / 100;

  const futureValue = monthlyInvestment * (
  (Math.pow(1 + monthlyRate, months) - 1) / monthlyRate) * (
  1 + monthlyRate);

  const totalInvestment = monthlyInvestment * months;
  const estimatedReturns = futureValue - totalInvestment;

  return {
    totalInvestment: Math.round(totalInvestment),
    estimatedReturns: Math.round(estimatedReturns),
    futureValue: Math.round(futureValue)
  };
};